import React, {Component} from "react";
import axios from "axios";

import {Navigate} from 'react-router-dom';
import mainLogo from '../mglogo.png';

class Login extends Component {


    constructor(props) {
        super(props);
        this.state = {
            showmsg: false,
            redirect: false,
            email: '',
            password: '',
            role: 0,
            success: 'false',
            error_list: [],
        };
    }

    handleInput = (e) => {

        this.setState({
            [e.target.name]: e.target.value
        });
    }


    loginUser = async (e) => {

        e.preventDefault();
        const res = await axios.post('api/login', this.state);

        if (res.data.success) {
            localStorage.setItem('token', res.data.token);
            localStorage.setItem('role', res.data.user.id_crypt);
            localStorage.setItem('role_id', res.data.user.role_id);
            this.setState({role: res.data.user.role_id});
            this.setState({showmsg: true})
            
            setTimeout(function () { //Start the timer
                this.setState({redirect: true}) //After 1 second, set render to true
            }.bind(this), 1000)


            this.setState({error_list: res.data.data});

        } else {
            this.setState({error_list: res.data});


        }
    }

    render() {

        let token = localStorage.getItem('token');
        let roleId = Number(localStorage.getItem('role_id'));

        if (token != null) {

            if (roleId === 1 || roleId === 2) {
                return <Navigate to={'/admin/dashboard'}/>
            }
            if (roleId === 3) {
                return <Navigate to={'/member/pay/list'}/>
            }

        }

        if (this.state.redirect) {
            if (this.state.role === 1 || this.state.role === 2) {
                return <Navigate to={'/filterby/Dashboard'}/>
            }
            if (this.state.role === 3) {
                return <Navigate to={'/member/pay/list'}/>
            }
        }

        return (


            <>
                {/*
            This example requires updating your template:

            ```
            <html class="h-full bg-gray-50">
            <body class="h-full">
            ```
          */}
                <div className="min-h-full flex flex-col justify-center py-12 sm:px-6 lg:px-8">
                    <div className="sm:mx-auto sm:w-full sm:max-w-md">
                        <img
                            className="mx-auto h-12 w-auto"
                            src={mainLogo}
                            alt="Your Company"
                        />
                        <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-gray-900">Sign in to your
                            account</h2>
                    </div>

                    <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
                        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
                            <form onSubmit={this.loginUser} className="space-y-6">
                                <div>
                                    <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                                        Email address
                                    </label>
                                    <div className="mt-1">
                                        <input
                                            id="email"
                                            name="email"
                                            type="text"
                                            onChange={this.handleInput}
                                            autoComplete="email"
                                            value={this.state.email}
                                            required
                                            className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                        />
                                    </div>
                                    <p className="mt-2 text-sm text-red-600" id="email-error">
                                        {this.state.error_list.email}
                                    </p>
                                </div>

                                <div>
                                    <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                                        Password
                                    </label>
                                    <div className="mt-1">
                                        <input
                                            id="password"
                                            name="password"
                                            type="password"
                                            onChange={this.handleInput}
                                            autoComplete="current-password"
                                            value={this.state.password}
                                            required
                                            className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                        />
                                    </div>
                                    <p className="mt-2 text-sm text-red-600" id="email-error">
                                        {this.state.error_list.password}
                                    </p>
                                </div>
                                <div>
                                    <button
                                        type="submit"
                                        className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                    >
                                        Sign in
                                    </button>
                                </div>
                                <p className="mt-2 text-sm text-red-600" id="email-error">
                                    {this.state.error_list.message ? this.state.error_list.message : ""}
                                    {this.state.error_list.password ? this.state.error_list.password : ""}
                                </p>
                            </form>
                            <div className="mt-6">
                                <div className="relative">
                                    <div className="absolute inset-0 flex items-center">
                                        <div className="w-full border-t border-gray-300"/>
                                    </div>
                                    <a href="https://dreamstech.co" target="_blank"
                                       className="group block w-full flex-shrink-0">
                                        <div className="relative flex justify-center text-sm">
                                            <span className="bg-white px-2  text-sky-500">Powered By Dreams</span>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </>
        )
    }

}

export default Login;


